<template>
    <header id="header" class="full-header" data-logo-height="62">
        <div id="header-wrap">
            <div class="container">
                <div class="header-row">

                    <div id="logo">
                        <router-link :to="{name:'Home'}" class="standard-logo" :data-mobile-logo="`${imgBase}Content/images/logo-lan-mobile.svg`"><img :src="`${imgBase}Content/images/logo-lan.svg`" alt="SCFHS Careers" style="height: 62px;"></router-link>
                        <router-link :to="{name:'Home'}" class="retina-logo" :data-mobile-logo="`${imgBase}Content/images/logo-lan-mobile.svg`"><img :src="`${imgBase}Content/images/logo-lan.svg`" alt="SCFHS Careers" style="height: 62px;"></router-link>
                        <!--<router-link :to="{name:'Home'}" class="router-link-active router-link-exact-active menu-link">   <img :src="`${imgBase}Content/images/logo-lan.svg`" alt="SCFHS Careers" /></router-link>-->
                    </div><!-- #logo end -->

                    <div class="header-misc" data-class-xl="header-misc" data-class-lg="header-misc"
                         data-class-md="header-misc" data-class-sm="header-misc w-100 d-flex justify-content-center"
                         data-class-xs="header-misc w-100 d-flex justify-content-center">
                        <a class="navbar-nav-link navbar-nav-link-toggler" href="#" data-toggle="dropdown" @click="ChangeLanguage">
                            <i class="fa-solid fa-earth-americas me-1"></i>
                            {{this.Language}}
                        </a>

                        <router-link :to="{name:'SignUp'}" class="btn btn-secondary btn-sm text-white mx-2 text-nowrap mb-2 mb-md-0">{{$t("HomePage-Register")}}</router-link>
                        <router-link :to="{name:'SignIn'}" class="btn btn-primary btn-sm text-nowrap mb-2 mb-md-0">{{$t("HomePage-SignIn")}}</router-link>

                    </div>

                    <div id="primary-menu-trigger">
                        <svg class="svg-trigger" viewBox="0 0 100 100">
                            <path d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20">
                            </path>
                            <path d="m 30,50 h 40"></path>
                            <path d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20">
                            </path>
                        </svg>
                    </div>

                    <!-- Primary Navigation
                    ============================================= -->
                    <nav class="primary-menu">

                        <ul class="menu-container">
                            <li class="menu-item">
                                <router-link :to="{name:'Home'}" class="menu-link">   <div> {{$t("HomePage-Home")}}</div></router-link>

                                <!--<a class="menu-link" href="index.html">
                                    <div>الصفحة الرئيسية</div>
                                </a>-->
                            </li>
                            <li class="menu-item">
                                <a class="menu-link" href="#">
                                    <div> {{$t("HomePage-Programs")}} </div>
                                </a>
                                <ul class="sub-menu-container">
                                    <li v-for="(itemProgram, index) in programs"  class="menu-item">
                                        <router-link :to="{name:'Programs', params:{id:itemProgram.id}}" class="menu-link">
                                            <div>{{ itemProgram.name }}</div>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="menu-item">
                                <router-link :to="{name:'CommonQuestions'}" class="menu-link">  <div> {{$t("HomePage-CommonQuestions")}}  </div></router-link>

                                <!--<a class="menu-link" href="faq.html">
                                    <div>الأسئلة الشائعة</div>
                                </a>-->
                            </li>
                            <li class="menu-item">
                                <a v-if="contactUsURL != null" class="menu-link" target="_blank" :href="contactUsURL">
                                    <div>{{$t("HomePage-ConnectWithUs")}}</div>
                                </a>
                                <a v-else class="menu-link" href="#">
                                    <div>{{$t("HomePage-ConnectWithUs")}}</div>
                                </a>
                            </li>
                        </ul>

                    </nav><!-- #primary-menu end -->

                </div>
            </div>
        </div>
        <div class="header-wrap-clone"></div>
    </header>
</template>
    <script>

        import * as homePageService from './Service/HomePageService'


        export default {
            name: 'headerComponent',
            data() {
                return { imgBase: process.env.BASE_URL, programs: [], Language: localStorage.getItem('Public_lang') == 'en-us' ? 'العربية' : 'English', contactUsURL:'' }
            },
            created() {
                debugger
                homePageService.getAllPrograms(this);

            },
            methods: {
                ChangeLanguage() {
                    homePageService.OnChangeLanguage(this);
                },
            },
        }

    </script>
<!--<style>
    .menu-link{
        padding: 18px 15px 18px 15px !important;
    }
</style>-->